// i18next-extract-mark-ns-start LaRubrique
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import withNavigation from '../../../hoc/withNavigation';
import { navigate } from '../../../services/navigation';
import { toFormattedBoldText } from '../../../services/formatting';
import { Button as StyledButton } from '../../home/v3/styledComponents';
import { colors, tabletThresholdPixels } from '../../home/v4/styledComponents';

const Container = styled.div`
  text-align: ${({ center }) => (center ? 'center' : 'left')};
  font-size: 18px;
  line-height: 25px;
`;

const mobileTitlePrefixShift = 40;
const Title2 = styled.h2`
  font-weight: bold;
  font-size: 32px;
  line-height: 45px;
  margin: 0px 0px 31px;
  position: relative;
  color: ${colors.black};

  @media (max-width: ${tabletThresholdPixels}) {
    font-size: 23px;
    line-height: 32px;
  }
`;

const Title3 = styled(Title2.withComponent('h3'))`
  font-weight: normal;
  font-size: 26px;
  line-height: 33px;

  @media (max-width: ${tabletThresholdPixels}) {
    font-size: 18px;
    line-height: 28px;
    left: ${mobileTitlePrefixShift}px;
    padding-right: ${mobileTitlePrefixShift}px;
  }
`;

const TitlePrefix = styled.span`
  position: absolute;
  left: -60px;

  @media (max-width: ${tabletThresholdPixels}) {
    left: -${mobileTitlePrefixShift}px;
  }
`;

const Paragraph = styled.p`
  margin: 0px;

  @media (max-width: ${tabletThresholdPixels}) {
    font-size: 14px;
    line-height: 20px;
  }
`;

const Button = styled(StyledButton)`
  margin-top: 40px;

  @media (max-width: ${tabletThresholdPixels}) {
    margin-top: 20px;
  }
`;

function BlockText({
  text, title, links, button, center,
}) {
  const { t } = useTranslation();
  return (
    <Container center={center}>
      {title && !title.prefix && (
        <Title2>{t(title.text)}</Title2>
      )}
      {title && (title.prefix || title.subTitle) && (
        <Title3>
          {title.prefix && (
            <TitlePrefix>
              {t(title.prefix)}
              {' — '}
            </TitlePrefix>
          )}
          {t(title.subTitle || title.text)}
        </Title3>
      )}
      {text && (
        <Paragraph>
          {toFormattedBoldText(t(text), 500, links, { fontWeight: 500, color: colors.grey200 })}
        </Paragraph>
      )}
      {button && (
        <Button black onClick={() => navigate(button.links)}>
          {t(button.text)}
        </Button>
      )}
    </Container>
  );
}

BlockText.propTypes = {
  text: PropTypes.string,
  title: PropTypes.shape({
    text: PropTypes.string,
    prefix: PropTypes.string,
    subTitle: PropTypes.string,
  }),
  center: PropTypes.bool,
  links: PropTypes.arrayOf(PropTypes.string),
  button: PropTypes.shape({
    text: PropTypes.string,
    links: PropTypes.string,
  }),
};

BlockText.defaultProps = {
  text: null,
  title: null,
  center: false,
  links: [],
  button: null,
};

export default withNavigation(BlockText);
